import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Switch, { Case } from "react-switch-case";
import { Link } from "react-router-dom";

import {
  fn_bridge_delivery_order_cancel_check,
  fn_bridge_order_all_complete,
  fn_bridge_order_cancel,
  fn_bridge_reload,
  fn_bridge_shopinfo_set,
  fn_bridge_baemin_agency_login,
  fn_bridge_order_state,
  fn_test_order,
  fn_bridge_pos_order_call,
} from "function/FnPosBridge";
import { fn_order_complete_layer, fn_print_set_type } from "function/FnBodyLayer";
import {
  fn_print_confirm,
  fn_payfree_info,
  fn_setOutAutoFlag,
  fn_setOutAutoAllFlag,
  fn_getOutAutoAllFlag,
  fn_delete_quick_addr,
  fn_setDeliveryFlagSet,
  fn_printOutInitChange,
  fn_return_auto_refund,
} from "function/FnBodySetting";
import { reload_order_list_all } from "http/OrderConn";
import { fn_bridge_order_accept } from "function/FnPosBridge";
import { fn_change_step, fn_send_order_delivery_complete } from "function/FnBodyStep";
import { fn_agency_holiday_change } from "http/SettingConn";
import { hungryPandaMobileOrderFg } from "utils/Utils";
import { useMappingMutaion } from "views/setting/hooks/useMappingMutaion";
import { CUSTOMER_SERVICE_CENTER } from "constants/order/serviceCenterConfig";

const AlertView = ({ rootStore }) => {
  const layerStore = rootStore.layerStore;
  const { mutate: updateOrderMapping } = useMappingMutaion(rootStore);
  let dlvMsg = rootStore.layerStore.getDeliveryErrMsg;
  dlvMsg = !dlvMsg ? "" : "(" + dlvMsg + ")";

  // 고객센터 정보 조회
  function getCustomerServiceInfo(mobileOrderFg) {
    return CUSTOMER_SERVICE_CENTER[mobileOrderFg] || "";
  }

  return (
    <div className={"layer_comm layer_common_type alert " + (layerStore.getLayerAlertView ? "layer_open" : "")}>
      <div className="bg"></div>
      <div className="layer_content">
        <div className="article_alert">
          <Switch condition={layerStore.getLayerAlertType}>
            {/*출력성공*/}
            <Case value="expectTimeError">
              <h1>시간선택</h1>
              <div className="txt">
                <p>고객 예상 수령시간을 선택해주세요.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            <Case value="print">
              <h1>출력완료</h1>
              <div className="txt">
                <p>출력에 성공 했습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            <Case value="print_delay">
              <h1>주방프린터 출력</h1>
              <div className="txt">
                <p>
                  매장 환경에 따라 출력이 지연될 수 있습니다.
                  <br />
                  잠시만 기다려주세요 (최대 10초)
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*품절 레이어 다음에 - 거절*/}
            <Case value="soldout_next">
              <h1>주문거절 완료</h1>
              <div className="txt">
                <p>주문을 거절하였습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertView(false);
                    layerStore.setLayerSoldOut(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*품절 레이어 다음에 - 취소*/}
            <Case value="soldout_next_cancel">
              <h1>주문취소 완료</h1>
              <div className="txt">
                <p>주문을 취소하였습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertView(false);
                    layerStore.setLayerSoldOut(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*품절 거절*/}
            <Case value="soldout_ok">
              <h1>품절처리 및 주문거절</h1>
              <div className="txt">
                <p>선택 메뉴 품절처리 및 주문거절을 완료하였습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*품절 취소*/}
            <Case value="soldout_cancel_ok">
              <h1>품절처리 및 주문취소</h1>
              <div className="txt">
                <p>선택 메뉴 품절처리 및 주문취소를 완료하였습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*실패 확인 */}
            <Case value="fail">
              <h1>처리 실패</h1>
              <div className="txt">
                <p>
                  처리에 실패 했습니다. <br />
                  {rootStore.layerStore.getAlertCustomMessage != ""
                    ? "(" + rootStore.layerStore.getAlertCustomMessage + ")"
                    : null}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setAlertCustomMessage("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*실패 확인 */}
            <Case value="failMsg">
              <h1>안내</h1>
              <div className="txt">
                <p>{rootStore.layerStore.getFailErrMsg}</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*실패 확인 */}
            <Case value="reprint_type_null">
              <h1>재출력 선택</h1>
              <div className="txt">
                <p>출력 양식을 선택해주세요.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배달대행 실패 */}
            <Case value="delivery_fail">
              <h1>배달요청 처리 실패</h1>
              <div className="txt">
                <p>
                  주소 수정후 다시 시도해주세요.
                  <br />
                  {dlvMsg}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배달대행 실패 */}
            <Case value="delivery_time_choice">
              <h1>배달요청 실패</h1>
              <div className="txt">
                <p>픽업요청시간을 선택 해주세요.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배달대행 조회중 */}
            <Case value="dlv_call_fail">
              <h1>배달요청 실패</h1>
              <div className="txt">
                <p>
                  배달 요청에 실패 했습니다.
                  <br />
                  {dlvMsg}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배달대행 조회중 */}
            <Case value="dlv_cancel_fail">
              <h1>배달취소 실패</h1>
              <div className="txt">
                <p>
                  배달 취소에 실패 했습니다.
                  <br />
                  {dlvMsg}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배달대행 조회중 */}
            <Case value="dlv_partner_fail">
              <h1>배달대행사 조회 실패</h1>
              <div className="txt">
                <p>
                  배달대행사 조회에 실패 했습니다.
                  <br />
                  {dlvMsg}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배달대행 조회중 */}
            <Case value="dlv_fee_fail">
              <h1>배달비조회 실패</h1>
              <div className="txt">
                <p>
                  배달비 조회에 실패 했습니다.
                  <br />
                  {dlvMsg}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배달대행 조회중 */}
            <Case value="dlv_not_call">
              <h1>배달정보 오류</h1>
              <div className="txt">
                <p>
                  배달요청 정보가 올바르지 않습니다.
                  <br />
                  {dlvMsg}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배달대행 조회중 */}
            <Case value="delivery_none">
              <h1>배달요청 실패</h1>
              <div className="txt">
                <p>
                  배달대행사가 없습니다.
                  <br />
                  {dlvMsg}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배차취소 처리*/}
            <Case value="dlv_canceled">
              <h1>배달취소</h1>
              <div className="txt">
                <p>
                  이미 배차취소 처리된 주문입니다.
                  <br />
                  {dlvMsg}
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*지난주문 내역 주문취소 처리*/}
            <Case value="end_order_cancel">
              <h1>주문 취소</h1>
              <dl className="txt">
                <dt>주문 취소 시, 포스 매출만 취소됩니다</dt>
                <dd>* 실제 환불 처리는 주문 채널의 고객센터를 통해 확인해주세요.</dd>

                {hungryPandaMobileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg) ? (
                  <dd className="info">(헝그리판다 고객센터 02-3700-5124)</dd>
                ) : (
                  <dd className="info">(먹깨비 고객센터 1644-7817)</dd>
                )}
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore, "end");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*지난주문 내역 주문취소 처리 네이버*/}
            <Case value="end_order_cancel_naver">
              <h1>주문 취소</h1>
              <dl className="txt">
                <dt>주문을 취소하시겠습니까?</dt>
                <dd>* 취소 시, 주문 금액이 환불 처리됩니다.</dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore, "end");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*주문취소 처리*/}
            <Case value="order_cancel">
              <h1>주문 취소</h1>
              <dl className="txt">
                <dt>주문 취소 시, 포스 매출만 취소됩니다</dt>
                <dd>* 실제 환불 처리는 주문 채널의 고객센터를 통해 확인해주세요.</dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*주문내역 후킹상품 주문거절 확인창*/}
            <Case value="order_reject">
              <h1>주문 거절</h1>
              <dl className="txt">
                <dt>주문을 거절하시겠습니까?</dt>
                <dd>
                  * 주문 거절 시, 포스에서는 결제 취소처리되나
                  <br />
                  실제 환불 처리는 주문 채널의 고객센터를 통해 확인해주세요.
                </dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*주문취소 사유 무시하고 즉시 처리*/}
            <Case value="order_nosoldout_reject">
              <h1>주문 거절</h1>
              <dl className="txt">
                <dt>주문을 거절하시겠습니까?</dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore, "orderChannel");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*주문수락 후 사유 무시하고 즉시 처리*/}
            <Case value="order_accept_reject">
              <h1>주문 취소</h1>
              <dl className="txt">
                <dt>주문을 취소하시겠습니까?</dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*지난주문내역에서 사유 무시하고 즉시 처리*/}
            <Case value="order_end_accept_reject">
              <h1>주문 취소</h1>
              <dl className="txt">
                <dt>주문을 취소하시겠습니까?</dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore, "end");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배차취소 처리*/}
            <Case value="alert_custom">
              <h1>{rootStore.layerStore.getAlertCustomTitle}</h1>
              <div className="txt">
                <p>{rootStore.layerStore.getAlertCustomMessage}</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setAlertCustomTitle("");
                    layerStore.setAlertCustomMessage("");
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*포스 연결 안됨 처리*/}
            <Case value="err_pos_bridge">
              <h1>연결 실패</h1>
              <div className="txt">
                <p>포스 연결에 실패 했습니다.</p>
              </div>
            </Case>

            {/*포스 연결 안됨 처리*/}
            <Case value="err_access_token">
              <h1>인증 실패</h1>
              <div className="txt">
                <p>포스 인증에 실패 했습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*프린터 설정 체크*/}
            <Case value="printer_set_view">
              <h1>프린터 설정 없음</h1>
              <div className="txt">
                <p>
                  프린터 설정이 없습니다.
                  <br />
                  프린터를 한 대 이상 설정 후 테스트해주세요.
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            <Case value="no_all_complete_order">
              <h1>알림</h1>
              <div className="txt">
                <p>완료 처리할 주문건이 없습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            <Case value="no_all_complete_order_check">
              <h1>알림</h1>
              <div className="txt">
                <p>
                  수락되지 않은 주문건이 있습니다.
                  <br />
                  화면에 표시 중인 모든 주문을 수락 후 진행해주세요.
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            <Case value="printer_action_view">
              <h1>테스트 출력확인</h1>
              <div className="txt">
                <p>
                  테스트 주문서가 출력되셨나요?
                  <br />
                  출력이 안된경우, 연결포트를 재설정 해주세요
                </p>
              </div>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  재설정
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_print_confirm(rootStore);
                  }}
                >
                  출력확인
                </button>
              </div>
            </Case>

            <Case value="all_complete_order">
              <h1>주문 완료처리 확인</h1>
              <div className="txt">
                {rootStore.viewStore.getAllCompleteBaeminList ? (
                  <p>
                    배달의민족 주문은 포스에서만 완료처리 됩니다.
                    <br />
                    그래도 표시 중인 주문 모두 완료처리 하시겠습니까?
                  </p>
                ) : (
                  <p>
                    완료처리 시 일부 주문정보에 대한 조회가 불가합니다.
                    <br />
                    화면에 표시 중인 주문을 모두 완료처리 하시겠습니까?
                  </p>
                )}
              </div>
              <div className="btn btns">
                {layerStore._st_layer_all_completed_nopaid_list.length <= 0 ? (
                  <span>
                    <button
                      type="button"
                      className="btn_cancel"
                      onClick={event => {
                        layerStore.setLayerAlertType("");
                        layerStore.setLayerAlertView(false);
                      }}
                    >
                      취소
                    </button>
                    <button
                      type="button"
                      onClick={event => {
                        layerStore.setLayerAlertType("");
                        layerStore.setLayerAlertView(false);
                        fn_bridge_order_all_complete(rootStore, true);
                      }}
                    >
                      확인
                    </button>
                  </span>
                ) : (
                  <span>
                    <button
                      type="button"
                      className="btn_cancel"
                      onClick={event => {
                        layerStore.setLayerAlertType("");
                        layerStore.setLayerAlertView(false);
                        fn_bridge_order_all_complete(rootStore, true);
                      }}
                    >
                      선불만 처리
                    </button>
                    <button
                      type="button"
                      onClick={event => {
                        layerStore.setLayerAlertType("");
                        layerStore.setLayerAlertView(false);
                        fn_bridge_order_all_complete(rootStore, false);
                      }}
                    >
                      선불 + 후불 모두처리
                    </button>
                  </span>
                )}
              </div>
              <div className="btn_close btn_close_comm">
                <button
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  <span>닫기</span>
                </button>
              </div>
            </Case>

            <Case value="delivery_order_cancel_check">
              <h1>배차 취소</h1>
              <dl className="txt">
                <dt>배차를 취소하시겠습니까?</dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_delivery_order_cancel_check(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            <Case value="printer_action_confirm">
              <h1>주문서 인식 테스트 안내</h1>
              <p className="txt_detail">
                테스트 주문서 확인중입니다.
                <br />
                정상 작동 여부를 별도 알림으로 알려드립니다!
              </p>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            <Case value="printer_same_not_setting">
              <h1>프린터 동시 설정 불가</h1>
              <p className="txt_detail">
                하나의 프린터에 동시 설정이 불가합니다.
                <br />
                접수프린터와 출력프린터가 다르게 설정해주세요.
              </p>

              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/* <Case value="delivery_order_cancel_check">
                                <h1>배차 취소</h1>
                                <dl className="txt">
                                    <dt>배차를 취소하시겠습니까?</dt>
                                </dl>
                                <div className="btn btns">
                                    <button type="button" className="btn_cancel" onClick={event => {
                                        layerStore.setLayerAlertType("");
                                        layerStore.setLayerAlertView(false);
                                    }}>취소</button>
                                    <button type="button" onClick={event => {
                                        layerStore.setLayerAlertType("");
                                        layerStore.setLayerAlertView(false);
                                        fn_bridge_delivery_order_cancel_check(rootStore);
                                    }}>확인</button>
                                </div>
                            </Case> */}

            {/*포스 연결 안됨 처리*/}
            <Case value="err_check_token">
              <h1>인증 확인 실패</h1>
              <div className="txt">
                <p>포스 인증 확인에 실패 했습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*사운드0일때 미리듣기 재생시 팝업*/}
            <Case value="sound_lever_zero">
              <h1>알림</h1>
              <div className="txt">
                <p>
                  프로그램 알림 볼륨이 0 입니다.
                  <br />
                  볼륨 조정후 다시 시도해주세요
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*주방동시출력 사용 안내 [무료]요금제*/}
            <Case value="pay_free_type">
              <h1>주방동시출력 사용 안내</h1>
              <dl className="txt p">
                <dt className="p">
                  배달매니저 이용시 사용 가능합니다.
                  <br />
                  지금 바로 신청하고 편리하게 이용하세요!
                  <br />
                </dt>
                <dd className="p">(신규 가입시 1개월 무료)</dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  닫기
                </button>
                <button
                  type="button"
                  onClick={event => {
                    fn_payfree_info(
                      rootStore,
                      "https://delivery.okpos.co.kr/?utm_source=kitchen&utm_medium=print&utm_campaign=promo2_plan",
                      "mktKitchenPrinting Button"
                    );
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  주방출력 사용해보기
                </button>
              </div>
            </Case>

            {/*문의접수 완료 확인*/}
            <Case value="vocs_confirm">
              <h1>알림</h1>
              <div className="txt">
                <p>
                  문의접수가 완료되었습니다.
                  <br />
                  확인 후 최대한 빠르게 연락드리겠습니다.
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*로그전송 완료 확인*/}
            <Case value="log_send_confirm">
              <h1>알림</h1>
              <div className="txt">
                <p>로그가 전송되었습니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*최대조회기간31일*/}
            <Case value="search_date_max">
              <h1>알림</h1>
              <div className="txt">
                <p>한번에 조회 가능한 기간은 최대 31일입니다.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    //fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            <Case value="auto_complete">
              {rootStore.settingStore.getSettingEachAutoProg.val == "Y" ? (
                <>
                  <h1>자동 완료 설정</h1>
                  <div className="txt">
                    <p>
                      설정 시, 배달대행사 호출이 불가하고 완료된 주문으로만 조회됩니다.
                      <br />
                      그래도 설정하시겠습니까?
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <h1>자동 완료 해제</h1>
                  <div className="txt">
                    <p>
                      해제 시, 주문이 접수상태로 등록되며 배달대행사 호출이 가능합니다.
                      <br />
                      자동완료 설정을 해제하시겠습니까?
                    </p>
                  </div>
                </>
              )}
              <div className="btn btns">
                <span>
                  <button
                    type="button"
                    className="btn_cancel"
                    onClick={event => {
                      layerStore.setLayerAlertType("");
                      layerStore.setLayerAlertView(false);
                    }}
                  >
                    취소
                  </button>
                  <button
                    type="button"
                    onClick={event => {
                      layerStore.setLayerAlertType("");
                      layerStore.setLayerAlertView(false);
                      fn_setOutAutoFlag(
                        rootStore,
                        rootStore.settingStore.getSettingEachAutoProg.key,
                        rootStore.settingStore.getSettingEachAutoProg.val
                      );
                    }}
                  >
                    확인
                  </button>
                </span>
              </div>
              <div className="btn_close btn_close_comm">
                <button
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  <span>닫기</span>
                </button>
              </div>
            </Case>

            <Case value="all_auto_complete">
              {rootStore.settingStore.getSettingOutAuto == false ? (
                <>
                  <h1>자동 완료 설정</h1>
                  <div className="txt">
                    <p>
                      설정 시, 배달대행사 호출이 불가하고 완료된 주문으로만 조회됩니다.
                      <br />
                      그래도 설정하시겠습니까?
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <h1>자동 완료 해제</h1>
                  <div className="txt">
                    <p>
                      해제 시, 주문이 접수상태로 등록되며 배달대행사 호출이 가능합니다.
                      <br />
                      자동완료 설정을 해제하시겠습니까?
                    </p>
                  </div>
                </>
              )}
              <div className="btn btns">
                <span>
                  <button
                    type="button"
                    className="btn_cancel"
                    onClick={event => {
                      layerStore.setLayerAlertType("");
                      layerStore.setLayerAlertView(false);
                    }}
                  >
                    취소
                  </button>
                  <button
                    type="button"
                    onClick={event => {
                      layerStore.setLayerAlertType("");
                      layerStore.setLayerAlertView(false);
                      fn_setOutAutoAllFlag(rootStore, !fn_getOutAutoAllFlag(rootStore));
                    }}
                  >
                    확인
                  </button>
                </span>
              </div>
              <div className="btn_close btn_close_comm">
                <button
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  <span>닫기</span>
                </button>
              </div>
            </Case>

            {/*프린터 추가 validation*/}
            <Case value="print_add_validation">
              <h1>알림</h1>
              <div className="txt">
                <p>연결 포트 및 출력 속도를 선택해주세요</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*프린터 삭제 알림*/}
            <Case value="print_delete">
              <h1>프린터 삭제</h1>
              <dl className="txt">
                <dt>삭제 하시겠습니까?</dt>
              </dl>
              <p id="print_delete"></p>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    let printList = rootStore.settingStore.getEtcPrinterInfo.addPrintSettings;
                    printList.splice(document.getElementById("print_delete").value, 1);
                    fn_bridge_shopinfo_set(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            <Case value="recent_addr_fail">
              <h1>알림</h1>
              <p className="txt_detail">
                주소가 수정되었습니다.
                <br />
                수정 주소 확인 후 배달요청을 재시도 해주세요.
              </p>

              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    rootStore.layerStore.setLayerDeliveryCall(false);
                    rootStore.viewStore.setDetailClose();
                    reload_order_list_all(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*주문전용 포스인 경우 */}
            <Case value="order_pos">
              <h1>안내</h1>
              <div className="txt">
                <p>
                  현재 사용중인 기기는 주문 전용 포스입니다. <br />
                  결제 가능한 포스에서 처리해주세요.
                  <br />
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_reload(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*주소키워드 삭제팝업*/}
            <Case value="quickAddr_delete_confirm">
              <h1>주소키워드 삭제</h1>
              <dl className="txt">
                <dt>선택한 키워드를 삭제하시겠습니까?</dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_delete_quick_addr(rootStore, document.getElementById("quickAddr").value);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*요기요 주문취소 처리*/}
            <Case value="ygy_order_cancel">
              <h1>주문 취소</h1>
              <dl className="txt">
                <dt>주문 취소 시, 포스 매출만 취소됩니다</dt>
                <dd>* 실제 환불 처리는 주문 채널의 고객센터를 통해 확인해주세요.</dd>
                <dd className="info">(요기요 고객센터 1661-5270)</dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore, "end");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            <Case value="baemin_order_cancel">
              <h1>안내</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>주문 취소가 불가합니다</strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 실제 주문 취소 및 환불 처리가 필요해요
                    <p>· 배민 고객센터로 문의해주세요 (080-849-0987)</p>
                  </li>
                  <li>
                    Q) 포스에서 매출만 취소하고 싶어요
                    <p>· 포스 &gt; [영수증관리]에서 매출을 반품처리 하세요</p>
                  </li>
                </ul>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배민OFF 처리*/}
            <Case value="baemin_status_off">
              <h1>안내</h1>
              <dl className="txt">
                <dt>현재 배민 로그아웃 상태입니다.</dt>
                <dd>배민 프로그램에 로그인해 주세요.</dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  닫기
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_baemin_agency_login(rootStore);
                  }}
                >
                  배민 로그인하기
                </button>
              </div>
            </Case>

            {/*배민미사용 포스*/}
            <Case value="baemin_use_off">
              <h1>안내</h1>
              <div className="txt">
                <p>
                  배민 프로그램을 로그인한 {rootStore.settingStore.getBaeminUseStatus.baeminUsePosNo}번 포스에서
                  <br />
                  다시 시도해주세요
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배민연동 실패 btn*/}
            <Case value="baemin_connect_fail">
              <h1>배민 연동 실패</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>배민 프로그램 연동에 실패했습니다</strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 배민 주문 접수는 어떻게 해야하나요?
                    <p>
                      · 배민 <strong>주문접수 프로그램</strong> 또는 <strong>모바일 앱</strong>을 이용해주세요
                    </p>
                  </li>
                  <li>
                    Q) 포스에 배민 매출을 등록하고 싶어요!
                    <p>
                      · <strong>[매출요약] &gt; [매출등록]</strong> 에서 매출을 수기로 등록해주세요
                    </p>
                  </li>
                </ul>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배민연동 실패 (고객호출)*/}
            <Case value="baemin_connect_fail_pickupCall">
              <h1>고객 호출</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>배민 프로그램 연동에 실패하여 픽업 호출이 불가합니다</strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 고객님께 픽업 요청 알림을 어떻게 해야하나요?
                    <p>· 주문 정보 내 고객 전화번호로 연락해주세요</p>
                    <p>· 배민 주문접수 프로그램 또는 모바일 앱을 이용해주세요</p>
                  </li>
                </ul>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배민연동 실패 (준비완료)*/}
            <Case value="baemin_connect_fail_ready">
              <h1>준비 완료</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>배민 프로그램 연동에 실패하여 준비 완료가 불가합니다</strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 준비 완료 처리를 어떻게 해야하나요?
                    <p>· 배민 주문접수 프로그램 또는 모바일 앱을 이용해주세요</p>
                  </li>
                </ul>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배민연동 실패 (배민상세조회)*/}
            <Case value="baemin_connect_fail_orderDetail">
              <h1>배민 상세 조회</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>배민 프로그램 연동에 실패하여 배민 주문 조회가 불가합니다</strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 배민 주문 상세 팝업 어떻게 확인하나요?
                    <p>· 배민 주문접수 프로그램 또는 모바일 앱을 이용해주세요</p>
                  </li>
                </ul>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*배민연동 실패 (주문거절)*/}
            <Case value="baemin_connect_fail_reject">
              <h1>주문 거절</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>
                    배민 프로그램 연동에 실패했습니다
                    <br />
                    포스에는 주문이 거절되나 실제 배민 주문은 거절되지 않습니다{" "}
                  </strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 배민 주문을 거절하고 싶어요
                    <p>· 배민 주문접수 프로그램 또는 모바일 앱을 이용해주세요</p>
                  </li>
                  <li>
                    Q) 포스에서 거절한 내역을 확인하고 싶어요
                    <p>· [배달매니저] &gt; [지난주문내역]에서 확인해주세요</p>
                  </li>
                </ul>
              </div>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_state(
                      rootStore,
                      rootStore.orderStore.getBaeminFailDetail.mobileOrderNo,
                      "",
                      rootStore.orderStore.getBaeminFailDetail.orderNo,
                      false
                    );
                  }}
                >
                  포스에서만 주문 거절
                </button>
              </div>
            </Case>

            {/*배민연동 실패 (주문수락)*/}
            <Case value="baemin_connect_fail_accept">
              <h1>주문 수락</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>
                    배민 프로그램 연동에 실패했습니다
                    <br />
                    포스에는 주문이 생성되나 실제 배민 주문은 접수되지 않습니다
                  </strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 배민 주문을 수락하고 싶어요
                    <p>· 배민 주문접수 프로그램 또는 모바일 앱을 이용해주세요</p>
                  </li>
                  <li>
                    Q) 포스에서 수락한 내역을 확인하고 싶어요
                    <p>· [배달매니저] &gt; [주문현황]에서 확인해주세요</p>
                  </li>
                </ul>
              </div>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_state(
                      rootStore,
                      rootStore.orderStore.getBaeminFailDetail.mobileOrderNo,
                      "",
                      rootStore.orderStore.getBaeminFailDetail.orderNo,
                      true
                    );
                  }}
                >
                  포스에서만 주문 수락
                </button>
              </div>
            </Case>

            {/*배민연동 실패 (주문취소)*/}
            <Case value="baemin_connect_fail_cancel">
              <h1>주문 취소</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>
                    배민 프로그램 연동에 실패했습니다
                    <br />
                    포스에는 주문이 취소되나 실제 배민 주문은 취소되지 않습니다
                  </strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 배민 주문을 취소하고 싶어요
                    <p>· 배민 주문접수 프로그램 또는 모바일 앱을 이용해주세요</p>
                  </li>
                  <li>
                    Q) 포스에서 취소한 내역을 확인하고 싶어요
                    <p>· [배달매니저] &gt; [지난주문내역]에서 확인해주세요</p>
                  </li>
                </ul>
              </div>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore);
                  }}
                >
                  포스에서만 주문 취소
                </button>
              </div>
            </Case>

            {/*배민연동 실패 (주문완료)*/}
            <Case value="baemin_connect_fail_complete">
              <h1>주문 완료</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>
                    배민 프로그램 연동에 실패했습니다
                    <br />
                    포스에는 주문이 완료되나 실제 배민 주문은 완료되지 않습니다
                  </strong>
                </p>
                <ul className="qa">
                  <li>
                    Q) 배민 주문을 완료하고 싶어요
                    <p>· 배민 주문접수 프로그램 또는 모바일 앱을 이용해주세요</p>
                  </li>
                  <li>
                    Q) Q) 포스에서 완료한 내역을 확인하고 싶어요
                    <p>· Q) 포스에서 완료한 내역을 확인하고 싶어요</p>
                  </li>
                </ul>
              </div>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_order_complete_layer(rootStore, rootStore.orderStore.getBaeminFailDetail.mobileOrderNo);
                  }}
                >
                  포스에서만 주문 완료
                </button>
              </div>
            </Case>
            {/*요기요 예상 조리시간 fixed 주문접수*/}
            <Case value="order_accept_ygy">
              <h1>안내</h1>
              <dl className="txt">
                {rootStore.viewStore.getOrderDetail.mobileOrderFg === "27" &&
                rootStore.viewStore.getOrderDetail.morderTypeCd == "P" ? (
                  <dt>
                    예상 픽업 시간은
                    <strong>
                      {rootStore.viewStore.getOrderDetail.estimatedCookingTime == 0
                        ? " " +
                          rootStore.viewStore.getOrderDetail.expectedPickupTime.substr(8, 2) +
                          ":" +
                          rootStore.viewStore.getOrderDetail.expectedPickupTime.substr(10, 2) +
                          " 입니다."
                        : " " + rootStore.viewStore.getOrderDetail.estimatedCookingTime + "분 후입니다."}
                    </strong>
                  </dt>
                ) : rootStore.viewStore.getOrderDetail.mobileOrderFg === "27" &&
                  rootStore.viewStore.getOrderDetail.morderTypeCd == "O" ? (
                  <dt>방문 예상 시간은 {rootStore.viewStore.getOrderDetail.reservedTime}입니다</dt>
                ) : (
                  <dt>
                    라이더 픽업 예상 시간은 {rootStore.viewStore.getOrderDetail.estimatedCookingTime}분 후 입니다.
                  </dt>
                )}
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_accept(
                      rootStore,
                      rootStore.viewStore.getOrderDetail.mobileOrderNo,
                      rootStore.viewStore.getOrderDetail.estimatedCookingTime,
                      rootStore.viewStore.getOrderDetail.orderNo
                    );
                    //fn_change_step(rootStore, '200');
                  }}
                >
                  주문접수
                </button>
              </div>
            </Case>

            {/*요기요 완료 처리*/}
            <Case value="ygy_order_complete">
              <h1>주문 완료처리</h1>
              <dl className="txt">
                <dt>
                  완료처리 시, 포스에서만 매출 생성됩니다
                  <br />
                  실제 주문 완료는 라이더가 배달 완료 후 처리됩니다
                </dt>
                <dd>*완료 처리 시, 일부 주문정보 조회가 불가합니다</dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_send_order_delivery_complete(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*주문 거절 취소 사유 선택*/}
            <Case value="changeCancelReason">
              <h1>안내</h1>
              <div className="txt">
                <p>사유를 선택해주세요.</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*예상 배달대행사 설정된 경우 연동 배달대행사 미사용 변경시*/}
            <Case value="dlv_setting_mainN">
              <h1>안내</h1>
              <dl className="txt">
                <dt>
                  [미사용] 설정 시, 배달요청 팝업에서 조회 불가하며
                  <br />
                  예상배달비 조회 대행사도 해제됩니다.{" "}
                </dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_setDeliveryFlagSet(rootStore, rootStore.settingStore.getCheckDlv, "Y", "mainUpdate", "N");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*예상 배달대행사 설정된 경우 연동 배달대행사 사용 변경시*/}
            <Case value="dlv_setting_mainY">
              <h1>안내</h1>
              <dl className="txt">
                <dt>
                  [사용] 설정 시, 배달요청 팝업에서 조회 가능하며
                  <br />
                  예상배달비 조회 대행사로 설정됩니다.{" "}
                </dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_setDeliveryFlagSet(rootStore, rootStore.settingStore.getCheckDlv, "N", "mainUpdate");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/* 요기요 연동 해제  팝업*/}
            <Case value="yogiyo_connect">
              <h1>안내</h1>
              <div className="txt">
                <p>
                  {rootStore.layerStore.getYgyShopItem.vendorNm}
                  <br />
                  {rootStore.layerStore.getMappingAction ? "연동을 진행 하시겠습니까?" : "연동을 해제 하시겠습니까?"}
                </p>
              </div>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    updateOrderMapping({
                      bizNo: rootStore.settingStore.getShopBizNo,
                      action: rootStore.layerStore.getMappingAction,
                      cd: rootStore.layerStore.getYgyShopItem.vendorId,
                      posNo: "",
                    });
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/* 배민 프로그램 미설치 안내 팝업 */}
            <Case value="baemin_disConnect">
              <h1>안내</h1>
              <dl className="txt">
                <dt>
                  배민 주문접수PC Lite가 설치되지 않아
                  <br />
                  설치를 먼저 진행합니다.
                </dt>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*테스트주문*/}
            <Case value="test_order">
              <h1>테스트 주문 안내</h1>
              <div className="txt baemin">
                <p className="baemin">
                  <strong>포스에 설정된 영수프린터에 테스트 주문서가 출력됩니다</strong>
                </p>
                <ul className="qa">
                  <li>
                    ★ 주의사항
                    <p>
                      · 테스트 주문 전에 <strong>주문접수 프린터를 영수프린터</strong>로 맞춰주세요
                      <span>(배달매니저 설정 &gt; 프린터 설정 &gt; 기본 설정)</span>
                    </p>
                    <p>
                      · 테스트 주문도 매출에 반영되므로, <strong>테스트 후 주문을 취소</strong>해주세요
                    </p>
                    <p>
                      · 배달대행사 테스트 시에는 <strong>기사가 호출되지 않도록 유의</strong>해주세요
                    </p>
                  </li>
                </ul>
              </div>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_test_order(rootStore);
                  }}
                >
                  테스트 주문 생성
                </button>
              </div>
            </Case>
            {/*프린터추가 포트 없을경우 */}
            <Case value="print_add_port">
              <h1>안내</h1>
              <div className="txt">
                <p>
                  포트가 없습니다
                  <br />
                  본 기기에 포트가 있는지 확인해주세요
                  <br />
                </p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*프란터설정 이동*/}
            <Case value="print_setting">
              <h1>안내</h1>
              <dl className="txt">
                <dt>설정된 프린터가 없습니다</dt>
                <dd>* [프린터 설정 &gt; 연동 출력 프린터]에서</dd>
                {rootStore.layerStore.getLayerPrintSetType == "test" ? (
                  <dd className="more">영수프린터를 설정한 후 다시 시도해주세요</dd>
                ) : (
                  <dd className="more">설정 후 다시 시도해주세요</dd>
                )}
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                {rootStore.layerStore.getLayerPrintSetType == "test" ? (
                  <button
                    type="button"
                    onClick={event => {
                      layerStore.setLayerAlertType("");
                      layerStore.setLayerAlertView(false);
                      fn_print_set_type(rootStore, "etc");
                    }}
                  >
                    설정하러 가기
                  </button>
                ) : (
                  <Link to={"/setting/default/printer_setting"}>
                    <button
                      type="button"
                      onClick={event => {
                        layerStore.setLayerAlertType("");
                        layerStore.setLayerAlertView(false);
                        rootStore.viewStore.setDetailClose();
                        fn_print_set_type(rootStore, "etc");
                      }}
                    >
                      설정하러 가기
                    </button>
                  </Link>
                )}
              </div>
            </Case>
            {/*프린터설정 초기화*/}
            <Case value="print_out_init">
              <h1>안내</h1>
              <dl className="txt">
                <dt>
                  출력물 설정값이 모두 기본값으로 복구됩니다
                  <br />
                  초기화 하시겠습니까?
                </dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_printOutInitChange(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*헝그리판다 주문거절,취소 처리*/}
            <Case value="panda_cancel">
              <h1>안내</h1>
              <dl className="txt">
                <dt>주문 취소는 고객센터에 문의해주세요</dt>
                <dd className="info">(헝그리판다 고객센터 02-3700-5124)</dd>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*조리완료 처리된 주문 */}
            <Case value="cooking_complete_fail">
              <h1>안내</h1>
              <dl className="txt">
                <dt>이미 조리완료 처리된 주문입니다</dt>
                <dd className="info">{getCustomerServiceInfo(rootStore.viewStore.getOrderDetail.mobileOrderFg)}</dd>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*요기요 휴무 상태 개점 여부*/}
            <Case value="ygy_holiday">
              <h1>안내</h1>
              <dl className="txt">
                {rootStore.settingStore.getAgencyHolidayState ? (
                  <dt>
                    현재 요기요 연동 매장 모두 휴무상태입니다
                    <br />
                    요기요 연동 매장을 모두 개점하시겠습니까?
                  </dt>
                ) : (
                  <dt>
                    현재 요기요 연동 매장 모두 개점상태입니다
                    <br />
                    요기요 연동 매장을 모두 휴무하시겠습니까?
                  </dt>
                )}
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_agency_holiday_change(rootStore);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*반품매출 처리 성공 */}
            <Case value="return_success">
              <h1>안내</h1>
              <dl className="txt">
                <dt>포스에서 반품 매출로 처리되었습니다</dt>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    //fn_return_success(rootStore, rootStore.settingStore.getReturnFailOn.pendingNo)
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*반품매출 처리 실패 */}
            <Case value="return_fail">
              <h1>안내</h1>
              <dl className="txt">
                <dt>
                  반품 매출 처리에 실패하였습니다.
                  <br />
                  잠시 후 재시도 해주세요
                </dt>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*이미 처리한 반품매출*/}
            <Case value="return_already">
              <h1>안내</h1>
              <dl className="txt">
                <dt>이미 반품 처리한 매출입니다</dt>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*반품 미처리 목록 삭제*/}
            <Case value="return_list_delete">
              <h1>안내</h1>
              <dl className="txt">
                <dt>반품 미처리 목록에서 삭제하시겠습니까?</dt>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    //fn_setReturnListInit(rootStore)
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_return_auto_refund(rootStore, rootStore.settingStore.getReturnFailOn.pendingNo, "list");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/* 위메프오/땡겨요 환불처리 취소 */}
            <Case value="refund_order_cancel">
              <h1>주문 취소</h1>
              <dl className="txt">
                <dt>
                  주문 취소 시, 주문 금액이 환불처리 됩니다.
                  <br />
                  주문을 취소하시겠습니까?
                </dt>
                <dd className="info top">{getCustomerServiceInfo(rootStore.viewStore.getOrderDetail.mobileOrderFg)}</dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_order_cancel(rootStore, "end");
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*요기요 취소처리 실패*/}
            <Case value="ygy_cancel">
              <h1>안내</h1>
              <dl className="txt">
                <dt>주문 취소에 실패했습니다</dt>
                <dd>* 주문 취소 문의는 요기요 고객센터를 이용해주세요.</dd>
                <dd className="info">(요기요 고객센터 1661-5270)</dd>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*호출 알림톡 수량 팝업*/}
            <Case value="call_type_send">
              <h1>안내</h1>
              <dl className="txt">
                <dt>알림톡을 충전해주세요</dt>
                <dd>{rootStore.layerStore.getAlarmCallMsg.msg}</dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  발송 취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_bridge_pos_order_call(rootStore, rootStore.viewStore.getOrderDetail, "send", "");
                  }}
                >
                  알림톡 발송
                </button>
              </div>
            </Case>
            {/*호출 알림톡 성공 팝업*/}
            <Case value="call_type_send_success">
              <h1>안내</h1>
              <dl className="txt">
                <dt>알림톡을 전송했습니다.</dt>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>
            {/*호출 알림톡,진동벨 실패 팝업*/}
            <Case value="call_type_send_fail">
              <h1>안내</h1>
              <dl className="txt">
                <dt>{rootStore.layerStore.getAlarmCallMsg.failMsg}</dt>
                <dd>
                  {rootStore.layerStore.getAlarmCallMsg.msg}
                  <br /> {rootStore.layerStore.getAlarmCallMsg.code == "DE5003" ? "(휴대폰번호 미입력 등)" : ""}
                </dd>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*테이블오더 주문취소 확인*/}
            <Case value="okdcCancel">
              <h1>안내</h1>
              <div className="txt">
                <p>포스 &gt; [영수증관리]에서 진행해주세요</p>
              </div>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*노쇼처리 가능시간 미경과시*/}
            <Case value="no_show_allowed_fail">
              <h1>안내</h1>
              <dl className="txt">
                <dt>고객이 방문하지 않으셨나요?</dt>
                <dd>도착시간보다 15분 이상 늦을 경우 미방문 처리할 수 있어요</dd>
              </dl>
              <div className="btn">
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  확인
                </button>
              </div>
            </Case>

            {/*노쇼처리 가능시간 경과시*/}
            <Case value="no_show_allowed_success">
              <h1>안내</h1>
              <dl className="txt">
                <dt>고객이 방문하지 않으셨나요?</dt>
                <dd>
                  사전 요청 없이 방문하지 않았다면 완료버튼을 눌러주세요 <br /> 해당 주문은 주문완료건으로 정산됩니다
                </dd>
              </dl>
              <div className="btn btns">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={event => {
                    layerStore.setLayerAlertType("");
                    layerStore.setLayerAlertView(false);
                    fn_change_step(rootStore, "700");
                  }}
                >
                  완료
                </button>
              </div>
            </Case>
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default inject("rootStore")(observer(AlertView));
